import { getPackage, getPackageVariables } from '__generated__/getPackage';
import { QueryHookOptions, useQuery } from 'react-apollo';
import query from './GetPackage.graphql';

export default function useGetPackage(
    options?: QueryHookOptions<getPackage, getPackageVariables> | undefined
) {
    return useQuery<getPackage, getPackageVariables>(query, options);
}
